<template>
  <div class="image-upload w-100">
    <!-- Upload -->
    <form
      enctype="multipart/form-data"
      novalidate
      v-if="isInitial || isSaving">

      <div class="dropbox">
        <b-form-file
            v-model="photo"
            multiple
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            :name="uploadFieldName"
            :state="Boolean(photo)"
            accept="image/*"
            @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" />

        <p v-if="isInitial"></p>

        <p v-if="isSaving">
          Uploading {{ fileCount }} file(s)...
        </p>


      </div>

    </form>

    <!-- Success -->
    <div v-if="isSuccess || hasPhoto">
      <p>
        <b-button
          @click="reset()"
          variant="outline-secondary"
          size="sm"
          class="py-0 ml-2">
          Upload again
        </b-button>
      </p>
      <ul class="list-unstyled">
        <li v-for="photo in uploadedPhotos" v-if="photo">
          <img
            :src="photo.url"
            class="img-responsive w-100 h-100" />
        </li>
      </ul>
    </div>

    <!-- Failed -->
    <div v-if="isFailed">
      <p>
        <a href="javascript:void(0)" @click="reset()">Try again</a>
      </p>
      <pre>{{ uploadError }}</pre>
    </div>
  </div>
</template>

<script>
  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3, STATUS_HAS_PHOTO = 4;

  export default {
    name: "ImageUpload",
    props: {
      photos: {
        type: Array,
      },
      size: {
        type: String,
        default: '600'
      }
    },
    data () {
      return {
        uploadedPhotos: [],
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'photos',
        photo: []
      }
    },
    computed: {
      isInitial () {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving () {
        return this.currentStatus === STATUS_SAVING;
      },
      hasPhoto () {
        return this.currentStatus === STATUS_HAS_PHOTO;
      },
      isSuccess () {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed () {
        return this.currentStatus === STATUS_FAILED;
      },
      image_size () {
        return 'image_' + this.size;
      }
    },
    methods: {
      reset () {
        this.currentStatus = STATUS_INITIAL;
        this.uploadedPhotos = [];
        this.photo = []
        this.uploadError = null;
      },
      getPhoto () {
        if (typeof this.photos !== 'undefined' && this.photos.length > 0) {
          this.currentStatus = STATUS_HAS_PHOTO;

          let targetPhoto = this.photos.find((item) => item.slug === this.image_size) || this.photos[0];

          this.uploadedPhotos = [].concat(targetPhoto);
          this.photo = [].concat(targetPhoto);
        }
      },
      save (formData) {
        this.currentStatus = STATUS_SAVING;
        this.upload(formData)
          .then(photo => {
            this.uploadedPhotos = [].concat(photo);
            this.currentStatus = STATUS_SUCCESS;
          })
          .catch(err => {
            this.uploadError = err.response;
            this.currentStatus = STATUS_FAILED;
          });
      },
      filesChange (fieldName, fileList) {
        const formData = new FormData();

        if (!fileList.length) return;

        Array
          .from(Array(fileList.length).keys())
          .map(photo => {
            formData.append(fieldName, fileList[photo], fileList[photo].name);
          });

        this.save(formData)
      },
      upload (formData) {
        const photos = formData.getAll('photos');
        this.$emit('send-image', formData);
        const promises = photos.map(photo => this.getImage(photo)
          .then(img => ({
            id: img,
            originalName: photo.name,
            fileName: photo.name,
            url: img,
            ext: photo.name.split('.')[1]
          }))
          .catch(err => console.log(err)));
        return Promise.all(promises);
      },
      getImage (file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          const img = document.createElement('img');

          reader.onload = () => {
            img.src = reader.result;
            resolve(this.getBase64Image(img));
          };

          reader.readAsDataURL(file);
        });
      },
      getBase64Image (img) {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        const dataUrl = img.src;

        return dataUrl;
      }
    },
    async mounted () {
      if (typeof this.photos !== 'undefined' && this.photos.length > 0) {
        this.getPhoto()
      } else {
        this.reset();
      }
    },
    watch: {
      photos () {
        this.getPhoto()
      }
    }
  }
</script>